import { render, staticRenderFns } from "./BizumPaymentForm.vue?vue&type=template&id=72c338d3"
import script from "./BizumPaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BizumPaymentForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports